import { DEFAULT_PAGE_SIZE as e, DEFAULT_PAGE as a } from "../constants.js";
const t = (e2) => `ТИС${(e2.data.length + 1).toString().padStart(6, "0")}`, r = { initialPageParam: { page: a, pageSize: e }, getNextPageParam: (e2, a2, t2) => {
  if (e2.length && !(e2.length < t2.pageSize)) return { page: t2.page + 1, pageSize: t2.pageSize };
} }, i = ({ page: t2, pageSize: r2 } = {}) => ({ initialPageParam: { page: t2 || a, pageSize: r2 || e }, getNextPageParam: (e2, a2, t3) => {
  if (e2.length && !(e2.length < t3.pageSize)) return { page: t3.page + 1, pageSize: t3.pageSize };
} }), g = (e2, { key: a2 = "id", selector: t2 }) => {
  var _a, _b, _c, _d, _e;
  try {
    let r2;
    const i2 = "function" == typeof a2 ? a2 : (t3) => t3[a2] === e2;
    if ((_a = t2 == null ? void 0 : t2.data) == null ? void 0 : _a.pages) {
      let e3 = (_c = (_b = t2 == null ? void 0 : t2.data) == null ? void 0 : _b.pages) == null ? void 0 : _c.flat();
      Array.isArray((_d = e3 == null ? void 0 : e3[0]) == null ? void 0 : _d.items) && (e3 = e3.reduce((e4, a3) => e4.concat(a3.items), [])), r2 = e3 == null ? void 0 : e3.find(i2);
    } else Array.isArray(t2 == null ? void 0 : t2.data) && (r2 = (_e = t2 == null ? void 0 : t2.data) == null ? void 0 : _e.find(i2));
    return r2;
  } catch (e3) {
    return void console.error(e3);
  }
}, n = (e2, a2, t2 = "id") => (r2) => (i2) => {
  var _a;
  const n2 = (_a = i2 == null ? void 0 : i2[e2]) == null ? void 0 : _a.queries;
  let p2;
  if (n2) for (const e3 in n2) e3.includes(a2) && (p2 = g(r2, { key: t2, selector: n2[e3] }));
  return p2;
};
function p(e2, a2) {
  return { ...e2, pageSize: a2 };
}
export {
  n as cachedItemByIdSelector,
  g as findById,
  t as generateId,
  r as infiniteQueryOptions,
  i as infiniteQueryOptionsFn,
  p as paramsWithPageSize
};
//# sourceMappingURL=utils.js.map
